"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  > :not(:first-child):not(:empty)::before {\n    content: '\xB7';\n    margin: 0 0.25em;\n  }\n  > :empty + :not(:empty)::before {\n    content: ' ';\n  }\n  > :not(:empty) ~ :empty + :not(:empty)::before {\n    content: '\xB7';\n    margin: 0 0.25em;\n  }\n  > * {\n    display: inline-block;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  > :not(:first-child):not(:empty)::before {\n    content: ', ';\n  }\n  > :empty + :not(:empty)::before {\n    content: ' ';\n  }\n  > :not(:empty) ~ :empty + :not(:empty)::before {\n    content: ', ';\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MiddotDelimitedList = exports.CommaDelimitedList = void 0;

var styledTypes_1 = require("./styledTypes");

exports.CommaDelimitedList = styledTypes_1.styled.span(_templateObject());
exports.MiddotDelimitedList = styledTypes_1.styled.span(_templateObject2());